<template>
    <div class="comments">
        <div class="chat-users">
            <div class="chat-conversation p-3" :class="[!loading && comments.length == 0 ? 'no-comments' : '']">
                <simplebar
                    style="max-height: 470px"
                    id="containerElement"
                    ref="current"
                >
                    <b-skeleton-wrapper :loading="loading">
                        <template #loading>
                            <ul class="list-unstyled">
                                <li>
                                    <div class="chat-day-title">
                                        <span class="title">Today</span>
                                    </div>
                                </li>
                                <li>
                                    <div class="conversation-list">
                                        <div class="ctext-wrap">
                                            <div class="conversation-name"><b-skeleton animation="fade" width="100px"/></div>
                                            <p class="mt-3">
                                                <b-skeleton animation="fade" width="300px"/>
                                                <b-skeleton animation="fade" width="300px"/>
                                                <b-skeleton animation="fade" width="250px"/>
                                            </p>
                                            <p class="chat-time mb-0 d-flex align-items-center">
                                                <i class="bx bx-time-five align-middle mr-1"></i>
                                                <b-skeleton animation="fade" width="20%"/>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="conversation-list">
                                        <div class="ctext-wrap">
                                            <div class="conversation-name"><b-skeleton animation="fade" width="120px"/></div>
                                            <p class="mt-3">
                                                <b-skeleton animation="fade" width="400px"/>
                                                <b-skeleton animation="fade" width="400px"/>
                                                <b-skeleton animation="fade" width="400px"/>
                                                <b-skeleton animation="fade" width="250px"/>
                                            </p>
                                            <p class="chat-time mb-0 d-flex align-items-center">
                                                <i class="bx bx-time-five align-middle mr-1"></i>
                                                <b-skeleton animation="fade" width="20%"/>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="conversation-list">
                                        <div class="ctext-wrap">
                                            <div class="conversation-name"><b-skeleton animation="fade" width="80px"/></div>
                                            <p class="mt-3">
                                                <b-skeleton animation="fade" width="200px"/>
                                            </p>
                                            <p class="chat-time mb-0 d-flex align-items-center">
                                                <i class="bx bx-time-five align-middle mr-1"></i>
                                                <b-skeleton animation="fade" width="20%"/>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </template>

                        <ul class="list-unstyled" v-if="comments.length">
                            <li>

                            </li>
                            <li
                                v-for="comment in comments"
                                :key="comment.id"
                            >
                                <div v-if="comment.delimiter" class="chat-day-title">
                                    <span class="title" v-if="moment().format('DD-MM-YYYY') == comment.date">Dzisiaj</span>
                                    <span class="title" v-else>{{ comment.date }}</span>
                                </div>
                                <div v-else class="conversation-list">
                                    <b-dropdown
                                        v-if="(user.clientDbid == comment.client_dbid && !comment.deleted_at && !comment.hidden_at && (cfg.edit || cfg.delete)) || (canHide && !comment.deleted_at)"
                                        variant="white"
                                    >
                                        <template v-slot:button-content>
                                            <i class="bx bx-dots-vertical-rounded"></i>
                                        </template>
                                        <b-dropdown-item
                                            v-if="user.clientDbid == comment.client_dbid && !comment.deleted_at && !comment.hidden_at && cfg.edit"
                                            @click="openEditModal(comment)"
                                        >
                                            <i class="fa fa-edit"></i> Edytuj
                                        </b-dropdown-item>
                                        <b-dropdown-item
                                            v-if="user.clientDbid == comment.client_dbid && !comment.deleted_at && !comment.hidden_at && cfg.delete"
                                            @click="deleteComment(comment.id)"
                                        >
                                            <i class="fa fa-trash"></i> Usuń
                                        </b-dropdown-item>

                                        <b-dropdown-item
                                            v-if="canHide && !comment.hidden_at && !comment.deleted_at"
                                            @click="openHideModal(comment)"
                                        >
                                            <i class="fa fa-eye-slash"></i> Ukryj
                                        </b-dropdown-item>
                                        <b-dropdown-item
                                            v-else-if="canHide && comment.hidden_at && !comment.deleted_at"
                                            @click="openShowHiddenModal(comment)"
                                        >
                                            <i class="fa fa-eye"></i> Pokaż
                                        </b-dropdown-item>
                                    </b-dropdown>
                                    <div class="ctext-wrap">
                                        <div class="conversation-name"><client :client="comment.client" withAvatar/></div>
                                        <p class="mt-3">
                                            <span v-if="comment.deleted_at"><i>Komenatrz został usunięty</i></span>
                                            <span v-else-if="comment.hidden_at"><i>Komenatrz został ukryty (Powód: {{ comment.hidden_reason }})</i></span>
                                            <span v-else>{{ comment.content }}</span>
                                        </p>
                                        <p class="chat-time mb-0 d-flex align-items-center">
                                            <i class="bx bx-time-five align-middle mr-1"></i>
                                            {{ comment.created_at | moment("DD-MM-YYYY HH:mm")}}
                                            <span class="ml-2" v-if="comment.updated_at && !comment.deleted_at && !comment.hidden_at"><i>(Edytowany: {{ comment.updated_at | moment("DD-MM-YYYY HH:mm")}})</i></span>
                                            <span class="ml-2" v-else-if="comment.deleted_at"><i>(Usunięty: {{ comment.deleted_at | moment("DD-MM-YYYY HH:mm")}})</i></span>
                                            <span class="ml-2" v-else-if="comment.hidden_at"><i>(Ukryty: {{ comment.hidden_at | moment("DD-MM-YYYY HH:mm")}})</i></span>
                                        </p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </b-skeleton-wrapper>
                </simplebar>
            </div>
        </div>
        <div class="p-3 chat-input-section">
            <form @submit.prevent="addComment" class="row d-flex align-items-center">
                <div class="col">
                    <div class="position-relative">
                        <textarea
                            v-model="newComment"
                            class="form-control"
                            placeholder="Wpisz treść..."
                            :class="{'is-invalid': $v.newComment.$error}"
                        ></textarea>
                        <div v-if="$v.newComment.$error" class="invalid-feedback">
                            <span v-if="!$v.newComment.required">Komentarz jest wymagany.</span>
                            <span v-if="!$v.newComment.minLength">Wprowadź co najmniej 5 znaków.</span>
                            <span v-if="!$v.newComment.maxLength">Wprowadź maksymalnie 1000znaków.</span>
                            <span v-if="!$v.newComment.badPhrases">Niedopuszczalna fraza w tekście.</span>
                        </div>
                    </div>
                </div>
                <div class="col-auto">
                    <button
                        type="submit"
                        class="btn btn-primary chat-send w-md"
                    >
                        <span class="d-none d-sm-inline-block mr-2">Dodaj komentarz</span>
                        <i class="mdi mdi-send"></i>
                    </button>
                </div>
            </form>
        </div>

        <b-modal
            id="modal-edit"
            centered
            title="Edytujesz swój komentarz"
            title-class="font-18"
        >
            <div>
                <form @submit.prevent="" class="row">
                    <div class="col">
                        <div class="position-relative">
                             <textarea
                                type="text"
                                v-model="editComment"
                                class="form-control"
                                placeholder="Wpisz treść..."
                                :class="{'is-invalid': $v.editComment.$error}"
                             ></textarea>
                            <div v-if="$v.editComment.$error" class="invalid-feedback">
                                <span v-if="!$v.editComment.required">Komentarz jest wymagany.</span>
                                <span v-if="!$v.editComment.minLength">Wprowadź co najmniej 5 znaków.</span>
                                <span v-if="!$v.editComment.maxLength">Wprowadź maksymalnie 1000 znaków.</span>
                                <span v-if="!$v.editComment.badPhrases">Niedopuszczalna fraza w tekście.</span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <template #modal-footer>
                <div class="w-100">
                    <b-button
                        variant="primary"
                        size="sm"
                        class="float-right"
                        @click="handleEdit"
                    >
                        <i class="fa fa-save"></i> Zapisz zmiany
                    </b-button>
                </div>
            </template>
        </b-modal>

        <b-modal
            id="modal-hide"
            centered
            title="Ukrywasz komentarz"
            title-class="font-18"
        >
            <div>
                <form @submit.prevent="" class="row">
                    <div class="col">
                        <div class="position-relative">
                             <textarea
                                 type="text"
                                 v-model="hideComment"
                                 class="form-control"
                                 placeholder="Wpisz powód ukrycia..."
                                 :class="{'is-invalid': $v.hideComment.$error}"
                             ></textarea>
                            <div v-if="$v.hideComment.$error" class="invalid-feedback">
                                <span v-if="!$v.hideComment.required">Powód ukrycia jest wymagany.</span>
                                <span v-if="!$v.hideComment.minLength">Wprowadź co najmniej 2 znaki.</span>
                                <span v-if="!$v.hideComment.maxLength">Wprowadź maksymalnie 100 znaków.</span>
                                <span v-if="!$v.hideComment.badPhrases">Niedopuszczalna fraza w tekście.</span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <template #modal-footer>
                <div class="w-100">
                    <b-button
                        variant="primary"
                        size="sm"
                        class="float-right"
                        @click="handleHide"
                    >
                        <i class="fa fa-eye-slash"></i> Ukryj komentarz
                    </b-button>
                </div>
            </template>
        </b-modal>

        <b-modal
            id="modal-showHidden"
            centered
            title="Podgląd ukrytego komentarza"
            title-class="font-18"
            :hide-footer="true"
        >
            <div>
                <form @submit.prevent="" class="row">
                    <div class="col">
                        <div class="position-relative">
                             <p>{{ currentComment.content }}</p>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
    </div>
</template>

<script>
import simplebar from "simplebar-vue";
import CommentsService from "@/services/comments.service"
import {maxLength, minLength, required} from "vuelidate/lib/validators";
import Vue from "vue";
import {notificationMethods} from "@/state/helpers";
import moment from 'moment';
import {
    hasGroup
} from "@/helpers/helper";
import badPhrases from "@/validators/badPhrases.validator";

export default {
    name: "Comments",
    props: {
        dbid: String
    },
    components: {simplebar},
    data() {
        return {
            loading: true,
            comments: [],
            newComment: "",
            editComment: "",
            currentComment: {},
            hideComment: ""
        }
    },
    validations: {
        newComment: {badPhrases: badPhrases, required: required, minLength: minLength(5), maxLength: maxLength(1000)},
        editComment: {badPhrases: badPhrases, required: required, minLength: minLength(5), maxLength: maxLength(1000)},
        hideComment: {badPhrases: badPhrases, required: required, minLength: minLength(2), maxLength: maxLength(100)},
    },
    computed: {
        user() {
            return this.$store.getters['auth/user'];
        },
        cfg() {
            return this.$store.getters['cfg/get'].panel.profile.comments;
        },
        canHide() {
            if (this.cfg.hide.enabled) {
                if (this.cfg.hide.canHideSelf && this.user.clientDbid == this.dbid)
                    return true;

                if (this.cfg.hide.adminGroups && this.hasGroup(Object.values(this.cfg.hide.adminGroups)))
                    return true;
            }

            return false;
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ...notificationMethods,
        hasGroup: hasGroup,
        moment: function () {
            return moment();
        },
        loadData() {
            this.loading = true;

            CommentsService.getClient(this.dbid).then(
                response => {
                    this.comments = response.data;
                    this.handleScroll();
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        handleScroll() {
            if (this.$refs.current.$el) {
                setTimeout(() => {
                    this.$refs.current.SimpleBar.getScrollElement().scrollTop = this.$refs.current.SimpleBar.getScrollElement().scrollHeight + 1500;
                }, 500);
            }
        },
        deleteComment(id) {
            Vue.swal.fire({
                title: 'Jesteś pewny?',
                text: "Nie będziesz mógł cofnąć tej operacji!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Tak, usuń!',
                cancelButtonText: 'Anuluj'
            }).then((result) => {
                if (result.value) {
                    this.loading = true;
                    CommentsService.delete(id).then(
                        () => {
                            this.success("Komentarz został usunięty");
                            this.loadData();
                        },
                        error => {
                            console.log(error);
                            this.loading = false;
                        }
                    )
                }
            });
        },
        addComment() {
            this.$v.newComment.$touch();

            if (this.$v.newComment.$invalid) {
                return;
            } else {
                this.loading = true;

                CommentsService.saveClient(this.dbid, this.newComment).then(
                    () => {
                        this.success("Komentarz został dodany");
                        this.newComment = "";
                        this.$v.$reset();
                        this.loadData();
                    },
                    error => {
                        console.log(error);
                        this.loading = false;
                    }
                )
            }
        },
        openEditModal(comment) {
            this.currentComment = comment;
            this.editComment = comment.content;
            this.$bvModal.show("modal-edit");
        },
        handleEdit() {
            this.$v.editComment.$touch();

            if (this.$v.editComment.$invalid) {
                return;
            } else {
                this.$bvModal.hide("modal-edit");
                this.loading = true;

                CommentsService.edit(this.currentComment.id, this.editComment).then(
                    () => {
                        this.success("Komentarz został zedytowany");
                        this.editComment = "";
                        this.currentComment = {};
                        this.$v.editComment.$reset();
                        this.loadData();
                    },
                    error => {
                        console.log(error);
                        this.loading = false;
                    }
                )
            }
        },
        openHideModal(comment) {
            this.currentComment = comment;
            this.hideComment = "";
            this.$v.hideComment.$reset();
            this.$bvModal.show("modal-hide");
        },
        handleHide() {
            this.$v.hideComment.$touch();

            if (this.$v.hideComment.$invalid) {
                return;
            } else {
                this.$bvModal.hide("modal-hide");
                this.loading = true;

                CommentsService.hide(this.currentComment.id, this.hideComment).then(
                    () => {
                        this.success("Komentarz został ukryty");
                        this.hideComment = "";
                        this.currentComment = {};
                        this.$v.hideComment.$reset();
                        this.loadData();
                    },
                    error => {
                        console.log(error);
                        this.loading = false;
                    }
                )
            }
        },
        openShowHiddenModal(comment) {
            this.currentComment = comment;
            this.$bvModal.show("modal-showHidden");
        },
    }
}
</script>

<style scoped>
    .no-comments {
        min-height: 0px!important;
    }
</style>